const EN_DASH = '–';

export function formatFloor(floorFrom?: number, floorTo?: number): string {
  if (!floorFrom && !floorTo) {
    return '';
  }

  const from = (floorFrom ?? floorTo) as number;
  const to = (floorTo ?? floorFrom) as number;

  if (from === to) {
    return `${from} этаж`;
  }

  if (to === from + 1) {
    return `${from} и ${to} этаж`;
  }

  return `${from} ${EN_DASH} ${to} этаж`;
}
